import { Vendor } from '../types/vendor'
import { mockVendors } from '../data/mockVendors'

/**
 * Maps a vendor from mockVendors to invoice supplier format
 */
export function getVendorDetails(vendorId: string) {
  const vendor = mockVendors.find((v) => v.id === vendorId)

  if (!vendor) {
    return null
  }

  // Map vendor data to invoice details format
  return {
    supplier: vendor.name,
    supplierABN: vendor.taxId || '',
    supplierCode: vendor.code,
    supplierPaymentTerms: vendor.paymentTerms || '',
  }
}

/**
 * Find vendor by name (for reverse lookup from invoice supplier name)
 */
export function findVendorByName(supplierName: string): Vendor | null {
  return mockVendors.find((v) => v.name === supplierName) || null
}

/**
 * Find vendor by code
 */
export function findVendorByCode(code: string): Vendor | null {
  return mockVendors.find((v) => v.code === code) || null
}
